exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "user-orders {\n  display: block;\n  margin-bottom: 20px;\n  /* Price */\n}\nuser-orders .price {\n  font-weight: 700;\n  font-size: 18px;\n}\nuser-orders .price span {\n  font-size: 14px;\n  font-weight: 500;\n  margin-left: 5px;\n}\nuser-orders .price.small {\n  font-size: 12px;\n  font-weight: 600;\n}\nuser-orders .price.small span {\n  font-size: 12px;\n}\nuser-orders .price.small.thin {\n  font-weight: 500;\n}", ""]);

// exports
